import { render, staticRenderFns } from "./AutobuyersTab.vue?vue&type=template&id=2cf6e922&scoped=true&"
import script from "./AutobuyersTab.vue?vue&type=script&lang=js&"
export * from "./AutobuyersTab.vue?vue&type=script&lang=js&"
import style0 from "./AutobuyersTab.vue?vue&type=style&index=0&id=2cf6e922&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf6e922",
  null
  
)

export default component.exports